function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { Observable } from '../../../utils/observables/observable';
import { SimpleTimer } from '../../../utils/simple-timer';
import { FlushMode } from './timed-data-gatherer.enums';
var DEFAULT_FLUSH_TIME_MS = 200;
/**
 * Utility class to gather data and emit it as a bulk array
 * if a new piece of added hasn't been added in [flushTimeMs] ms
 */ export var TimedDataGatherer = /*#__PURE__*/ function() {
    "use strict";
    function TimedDataGatherer(config) {
        _class_call_check(this, TimedDataGatherer);
        _define_property(this, "buffer", void 0);
        _define_property(this, "flushTimer", new SimpleTimer());
        _define_property(this, "bulkDataObservable", void 0);
        _define_property(this, "flushTimeMs", DEFAULT_FLUSH_TIME_MS);
        _define_property(this, "flushMode", FlushMode.Timed);
        this.buffer = [];
        this.bulkDataObservable = new Observable();
        var _config_flushTimeMs;
        this.flushTimeMs = (_config_flushTimeMs = config.flushTimeMs) !== null && _config_flushTimeMs !== void 0 ? _config_flushTimeMs : DEFAULT_FLUSH_TIME_MS;
        this.flushMode = config.flushMode;
    }
    _create_class(TimedDataGatherer, [
        {
            key: "push",
            value: /**
     * Push a piece of data into the buffer
     * @param data
     */ function push(data) {
                this.buffer.push(data);
                if (this.flushMode === FlushMode.Timed) {
                    this.flushTimer.start({
                        timeMs: this.flushTimeMs,
                        callback: this.flush.bind(this)
                    });
                }
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                this.flushTimer.destroy();
                this.buffer = [];
                this.bulkDataObservable.unregisterObservers(this);
            }
        },
        {
            key: "onBulkData",
            value: /**
     * Emitted when a piece of data hasn't been pushed into the buffer
     * in [flushTimeMs] ms
     * @param callback
     */ function onBulkData(callback) {
                this.bulkDataObservable.registerObserver(callback, this);
            }
        },
        {
            key: "flush",
            value: function flush() {
                this.bulkDataObservable.notifyObservers(this.buffer);
                this.buffer = [];
            }
        }
    ]);
    return TimedDataGatherer;
}();

//# sourceMappingURL=timed-data-gatherer.js.map